<template>
	<div class="pointer plr-10 co-0066FF">
		<!-- 编辑按钮 -->
		<div @click="Operate">{{ translate.ShowText('编辑') }}</div>
	</div>
</template>

<script lang="ts" setup>
	import translate from '@/api/translate';

	const emits = defineEmits(["change"]);
	
	const Operate = () => {
		emits("change");
	}
</script>

<style lang="scss" scoped>
</style>